import styled from 'styled-components'
import {
    textColorStyles,
    textSizeStyles,
    textWeightStyles,
} from '../text/textStyles'

export const Tag = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    border-radius: 20px;
    background-color: ${(p) => p.theme.colors.white};
    border: 1px solid ${(p) => p.theme.colors.tertiary.tertiary300};
    padding: 4px 10px;
    width: fit-content;
    white-space: nowrap;
    overflow: hidden;
    flex: 0 0 AUTO;
    gap: 8px;

    ${textSizeStyles['xxxSmall']}
    ${textWeightStyles['semiBold']}
    ${textColorStyles['secondary']}
`
